import Header from "./Component/Header";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Form } from "react-router-dom";
import Shop from "./Component/Shop";
import Contact_us from "./Component/Contact_us";
import Checkout from "./Component/Checkout";
import Myaccount from "./Component/Myaccount";
import Blog from "./Component/Blog";
import Login from "./Component/Login";
import Single_products from "./Component/Single_products";
import Offer from "./Component/Offer";
import Order from "./Component/Order";
import Aboutus from "./Component/Aboutus";
import FruitsandVagetables from "./Component/FruitsandVagetables";
import Shops_category from "./Component/Shops_category";
import CardList from "./Component/CardList";
import Favratewishlist from "./Component/Favratewishlist";
import SearchProducts from "./Component/SearchProducts";
import Shearch_mobile from "./Component/Shearch_mobile";
import Track_order from "./Component/Track_order";
import Moblle_category from "./Component/Moblle_category";
import Counter from "./Component/Counter";
import Zooming from "./Component/Zooming";
import Shubh from "./Component/Shubh";
import Dommy from "./Component/Dommy";
import Signin from "./Component/Signin";
import PrivacyAndPolicy from "./Component/PrivacyAndPolicy";
import TermsAndCondition from "./Component/TermsAndCondition";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Header />}></Route>
        <Route path="/shop" element={<Shop />}></Route>
        <Route path="/login" element={<Signin />}></Route>
        <Route path="/shopscategory" element={<Shops_category />}></Route>
        <Route path="/shop_grid4" element={<Blog />}></Route>
        <Route path="/contect_us" element={<Contact_us />}></Route>
        <Route path="/checkout" element={<Checkout />}></Route>
        <Route path="/myaccount" element={<Myaccount />}></Route>
        {/* <Route path="/login" element={<Login />}></Route> */}
        <Route path="/single_products/:id" element={<Single_products />}></Route>
        <Route path="/Favratewishlist" element={<Favratewishlist />}></Route>
        <Route path="/cardlist" element={<CardList />}></Route>
        <Route path="/offer" element={<Offer />}></Route>
        <Route path="/order" element={<Order />}></Route>
        <Route path="/aboutus" element={<Aboutus />}></Route>
        <Route path="/privacy-policy" element={<PrivacyAndPolicy />}></Route>
        <Route path="/terms-conditions" element={<TermsAndCondition />}></Route>
        <Route
          path="/fruits_vagetables"
          element={<FruitsandVagetables />}
        ></Route>
        <Route path="/SearchProducts" element={<SearchProducts />}></Route>
        <Route path="/Shearch_mobile" element={<Shearch_mobile />}></Route>
        <Route path="/track_order" element={<Track_order />}></Route>
        <Route path="/mobile_category" element={<Moblle_category />}></Route>

        <Route path="/counter" element={<Counter />}></Route>
        <Route path="/zooming" element={<Zooming />}></Route>
        <Route path="/shubh" element={<Shubh />}></Route>
        <Route path="/chk" element={<Dommy />}></Route>
      </Routes>
    </Router>

   // <div>
    //   <Mainbar/>
    //   <Header/>
    //   <Slidere/>
    //   <Freshfruit/>
    //   <Dealsoftheday/>
    //   <Fruits/>
    //   <Banner/>
    //   <Newarrivals/>
    //   <Gerocery/>
    //   <Featuredproducts/>
    //   <Audiojungle/>
    //   <Milkegg/>
    //   <Downloadapp/>
    //   <Security/>
    //   <Footer/>
  // </div>

  );
}

export default App;
